import { create } from "zustand";
import type { PaymentStatus } from "../api/bookings";

export type BookingModal = "cancel" | "reschedule" | "edit" | "detail" | null;

export interface BookingsFilters {
  dateFrom: string | null;
  dateTo: string | null;
  service: string;
  status: string;
  paymentStatus: PaymentStatus | "";
}

export interface PendingSyncRetry {
  bookingId: string;
  action: "cancel" | "reschedule" | "update_title";
  newDatetime?: string;
  newTitle?: string;
}

export interface BookingsUIState {
  filters: BookingsFilters;
  page: number;
  pageSize: number;
  activeModal: BookingModal;
  selectedBookingId: string | null;
  pendingSyncRetry: PendingSyncRetry | null;
  setFilters: (partial: Partial<BookingsFilters>) => void;
  setPage: (page: number) => void;
  openModal: (modal: BookingModal, bookingId: string) => void;
  closeModal: () => void;
  setSelectedBooking: (bookingId: string | null) => void;
  setPendingSyncRetry: (payload: PendingSyncRetry | null) => void;
  reset: () => void;
}

const defaultFilters: BookingsFilters = {
  dateFrom: null,
  dateTo: null,
  service: "",
  status: "",
  paymentStatus: "",
};

export const useBookingsStore = create<BookingsUIState>((set) => ({
  filters: { ...defaultFilters },
  page: 1,
  pageSize: 10,
  activeModal: null,
  selectedBookingId: null,
  pendingSyncRetry: null,

  setFilters: (partial) =>
    set((state) => ({
      filters: { ...state.filters, ...partial },
      page: 1,
    })),

  setPage: (page) => set({ page }),

  openModal: (modal, bookingId) =>
    set({ activeModal: modal, selectedBookingId: bookingId }),

  closeModal: () => set({ activeModal: null, selectedBookingId: null }),

  setSelectedBooking: (bookingId) => set({ selectedBookingId: bookingId }),

  setPendingSyncRetry: (payload) => set({ pendingSyncRetry: payload }),

  reset: () =>
    set({
      filters: { ...defaultFilters },
      page: 1,
      pageSize: 10,
      activeModal: null,
      selectedBookingId: null,
      pendingSyncRetry: null,
    }),
}));
